module.exports = __webpack_public_path__ + "img/47_12.9f94665b.png";